const addTableWrapper = (tableElement: HTMLTableElement): HTMLDivElement => {
  const div = document.createElement('div');
  div.classList.add('table-wrapper');
  if (tableElement.parentNode) {
    tableElement.parentNode.insertBefore(div, tableElement);
  }
  div.appendChild(tableElement);
  return div;
};

const applyShadowToFirstColumn = (tableWrapper: HTMLDivElement) => {
  tableWrapper.addEventListener('scroll', () => {
    const firstColumn = [
      ...tableWrapper.querySelectorAll('td:first-child'),
      tableWrapper.querySelector('th:first-child'),
    ];
    const shouldShowShadow = tableWrapper.scrollLeft > 0;

    firstColumn.forEach((cell) => {
      if (cell) {
        if (shouldShowShadow) {
          cell.classList.add('scroll-shadow');
        } else {
          cell.classList.remove('scroll-shadow');
        }
      }
    });
  });
};

const restoreTableStyles = (tableElement: HTMLTableElement): void => {
  tableElement.style.maxWidth = 'none';
  tableElement.style.overflow = 'auto';
};

export const scrollableTables = (tables: NodeListOf<HTMLTableElement>) => {
  tables.forEach((tableElement) => {
    if (tableElement) {
      restoreTableStyles(tableElement);
      const tableWrapper = addTableWrapper(tableElement);
      applyShadowToFirstColumn(tableWrapper);
    }
  });
};
